import { render, staticRenderFns } from "./join-page.vue?vue&type=template&id=3f9feb0c&"
import script from "./join-page.vue?vue&type=script&lang=js&"
export * from "./join-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports